import React from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined';

const AnnotationPanel = ({
  annotationMode,
  setAnnotationMode,
  annotationText,
  setAnnotationText,
  tool,
}) => {
  if (annotationMode !== "annotate" || tool !== "3D") return null;

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        bgcolor: "background.paper",
        borderRadius: 3,
        boxShadow: 3,
        zIndex: 1000,
        minWidth: "500px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          bgcolor: "#112138",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <AddCommentOutlinedIcon fontSize="small" />
          <Typography variant="subtitle2" fontWeight={600}>
            Add Annotation
          </Typography>
        </Box>
        <IconButton
          size="small"
          sx={{
            color: "#fff",
            "&:hover": { bgcolor: "rgba(255, 255, 255, 0.1)" },
          }}
          onClick={() => {
            setAnnotationText("");
            setAnnotationMode(null);
          }}
        >
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={{ p: 2, display: "flex", gap: 1, alignItems: "center" }}>
        <TextField
          size="small"
          fullWidth
          placeholder="Enter annotation text..."
          value={annotationText}
          onChange={(e) => setAnnotationText(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              // User will click on the 3D model to place annotation
            }
          }}
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-root": {
              color: "#000",
            },
          }}
        />
        <Typography variant="caption" sx={{ color: "#666", whiteSpace: "nowrap" }}>
          Click on model to place
        </Typography>
      </Box>
    </Box>
  );
};

export default AnnotationPanel;
